import Place from "@mui/icons-material/Place";
import { Collapse } from "@mui/material";

//SERVICES
import { GetShippingCompaniesResponse } from "@/main/models/response/packingTrackingHistoryResponse";
import { getTranslateByKey } from "@/main/services/utils";

//COMPONENTS
import LoadingComponent from "@/main/components/shared/loading/loadingComponent";
import RowLabel from "@/main/components/common/rowLabel/rowLabel";

import * as S from "./styles";

interface SeeShippingCompanies {
	isLoadingDataSeeShippingCompanies: boolean;
	dataSeeShippingCompanies: GetShippingCompaniesResponse[];
	checked: boolean;
	shippingCompanyLogo: string;
}

function SeeShippingCompanies({
	isLoadingDataSeeShippingCompanies,
	dataSeeShippingCompanies,
	checked,
	shippingCompanyLogo,
}: SeeShippingCompanies) {
	if (isLoadingDataSeeShippingCompanies) return <LoadingComponent />;

	return (
		<>
			<S.Container>
				<div>
					<Collapse in={checked}>
						<img src={shippingCompanyLogo} alt="" style={{ width: "25%", marginBottom: "1rem" }} />
						{dataSeeShippingCompanies?.map((company, index) => (
							<S.CardCompany key={index}>
								<S.State>{`${company.city} - ${company.state}`}</S.State>
								<S.ContainerInfo>
									<S.ContainerLocation>
										<Place fontSize="large" color="primary" />
										<S.Location>{company.unitMeasurement}</S.Location>
									</S.ContainerLocation>
									<S.ColumnInfo>
										<RowLabel label={getTranslateByKey("information.street")} content={company.street} />
										<RowLabel label={getTranslateByKey("information.neighborhood")} content={company.neighborhood} />
										<RowLabel label={getTranslateByKey("information.zipCode")} content={company.zipCode} />
										<RowLabel label={getTranslateByKey("information.phone")} content={company.cellphone} />
										<RowLabel label={getTranslateByKey("information.businessHour")} content={company.businessHour} />
									</S.ColumnInfo>
								</S.ContainerInfo>
							</S.CardCompany>
						))}
					</Collapse>
				</div>
			</S.Container>
		</>
	);
}

export default SeeShippingCompanies;
